<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 start-project">
      <StartCard1
        v-if="currentCard === 1"
        v-bind:request="request"
        v-on:next="nextCard"
        v-on:grabPhotos="savePhotos"
        v-on:setTime="saveTime"
      />
      <StartCard2
        v-if="currentCard === 2"
        v-bind:request="request"
        v-bind:projects="projects"
        v-on:next="nextCard"
        v-on:prev="prevCard"
        v-on:getAddress="updateExisting"
        v-bind:existingaddress.sync="existingaddress"
      />
      <StartCard3
        v-if="currentCard === 3"
        v-bind:request="request"
        v-on:prev="prevCard"
        v-on:submit="submitAts"
        v-bind:loadingWait="loadingWait"
      />
    </div>
  </div>
</template>
<script>

import api from '@/api';
import StartCard1 from "@/pages/Dashboard/ProjectPages/Components/StartCard1.vue";
import StartCard2 from "@/pages/Dashboard/ProjectPages/Components/StartCard2.vue";
import StartCard3 from "@/pages/Dashboard/ProjectPages/Components/StartCard3.vue";
import idx from 'idx';

export default {
  components: {
    StartCard1,
    StartCard2,
    StartCard3
  },
  mounted() {
      api.getUserDataAndProjects(this.$store.state.user.id).then((response) => {
        console.log(response);
        //for choose existing project dropdown on card 2
        this.projects = idx(response, _ => _.data.projects);
        this.projects.splice(0, 0, {job_name: 'Clear Existing Project'})

        //for company and user on card 2
        this.request.user = idx(response, _ => _.data.user);
        this.request.company = idx(response, _ => _.data.company);
        this.request.company.address = idx(response, _ => _.data.company_address);

        //for autofill on card 3
        this.request.signed_company_name = idx(response, _ => _.data.company.company_name);
        this.request.signed_user_name = idx(response, _ => _.data.user.full_name);

      })

  },
  data() {
    let now = new Date()
    return {
      currentCard: 1,
      projects: [],
      existingaddress: '',
      loadingWait: false,
      photos: [],
      request: {
        project_type: '',
        project_private: 1,
        requested_start_date: now,
        requested_start_time: '7:00 AM',
        building_type: '',
        type_to_be_scanned: '',
        gpr_scan_for_coring: '',
        gpr_scan_for_floor_sawing: '',
        gpr_scan_for_beams_or_columns: '',
        gpr_scan_for_vids_utilities_or_underground_detection: '',
        additional_info: '',
        job_name: '',
        address_attributes: {
          street_address: '',
          second_street_address: '',
          city: '',
          state: '',
          zip_code: ''
        },
        purchase_order_number: '',
        job_number: '',
        company: {
          company_name: '',
          address: {
            street_address: '',
            second_street_address: '',
            city: '',
            state: '',
            zip_code: ''
          },
          office_phone: '',
        },
        user: {
          first_name: '',
          last_name: '',
          phone_number: '',
          email: ''
        },
        site_contact_attributes: {
          first_name: '',
          last_name: '',
          phone_number: '',
          email: ''
        },
        coring_by_ibgw: '',
        terms_of_agreement: '',
        customer_signature: '',
        signed_company_name: '',
        signed_user_name: '',
      }
    };
  },
  methods: {
    submitAts() {
      // this.loadingWait = true;
      console.log(this.request)
      api
        .submitAtsRequest(this.request)
        .then((response) => {
          this.errors = {};
          console.log(this.photos);
          if (this.photos.length > 0){
            var formData = new FormData();
            console.log('photos', this.photos);
            this.photos.forEach((file) => {
              formData.append('file[]', file);
            })
            api.uploadFileToProject(response.data.project.id, formData).then((r) => {
              this.$router.push({ path: `/projects/${response.data.project.id}` })
            })
          } else {
            this.$router.push({ path: `/projects/${response.data.project.id}` })
          }
        }).catch(errors => {
          this.errors = errors;
          console.log(errors);
        });
    },
    nextCard(currentATSCard) {
      console.log('in next card');
      let newCard = currentATSCard + 1;
      this.currentCard = newCard;
      window.scrollTo(0,0);
    },
    prevCard(currentATSCard){
      let newCard = currentATSCard - 1;
      this.currentCard = newCard;
      window.scrollTo(0,0);
    },
    savePhotos(files){
      this.photos = files;
      console.log(this.photos)
      console.log(this.photos.length)
    },
    notifyVue(message, color) {
      // var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        timeout: 2500,
        message: message,
        horizontalAlign: 'left',
        verticalAlign: 'top',
        type: color
      });
    },
    updateExisting(address) {
      console.log('here!!')
      this.existingaddress = address;
      console.log(address);
    },
    saveTime(time){
      this.request.requested_start_time = time;
    }
  },

};
</script>
<style lang="scss">
  .md-checkbox-container {
    input {
      left: -999em !important;
    }
  }
  .spacer {
    width: 100%;
    height: 20px;
  }
  .md-list-item-content {
    &:hover {
      span {
        color: white !important;
      }
    }
  }
  // .ats-select {
    .md-select-menu {
      max-width:600px;
      // margin-top: 40px;
    }
  // }

  // .employees {
  //   height: 100px;
  //   border: 1px solid blue;
  //   background-color: darkgray;
  //   overflow-y: scroll;
  //   padding-left: 10px;
  //   p {
  //     color: white;
  //   }
  // }
</style>



<!-- <VueSignaturePad width="500px" height="500px" ref="signaturePad" />
 <div>
   <md-button class="md-sm md-info" v-on:click="save">Save</md-button>
   <md-button class="md-sm md-info" v-on:click="undo">Undo</md-button>
 </div> -->
